module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Italic.c736c72a.woff2";